import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { Radio } from '../../../../tornado/radio/radio.component';
import { getInitialStyle, unFocusedStyle, focusedStyle } from './trackItem.style';
import { getFinalHeight } from '../../../../tornado/radio/radio.style';

export class TrackItem extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Background: {
          rect: true,
        },
        Radio: {
          type: Radio,
        },
      },
      getInitialStyle(),
    );
  }

  get label() {
    return this.tag('Radio').label;
  }

  set label(value) {
    const labelRect = this.tag('Radio').tag('Label');
    labelRect.on('txLoaded', () => {
      this.h = getFinalHeight(labelRect.finalH);
    });
    this.tag('Radio').label = value;
  }

  get isSelected() {
    return this.tag('Radio').isSelected;
  }

  set isSelected(value) {
    this.tag('Radio').isSelected = value;
  }

  _focus() {
    this.patch(focusedStyle);
  }

  _unfocus() {
    this.patch(unFocusedStyle);
  }
}
